import Template from '../template'
import termsAndConditionsSource from './terms.md'

const termsAndConditions = {
  ...termsAndConditionsSource.attributes,
  body: new Template(termsAndConditionsSource.body),
}

export default { termsAndConditions }
